// @flow

import * as React from "react";
import sanitizeHtml from "sanitize-html-react";
import * as constants from "./constants";

import "./WebPage.css";

type Props = {
  title: string,
  contentHTML: string
};

const WebPage = (props: Props) => {
  const sanitizedContent = props.contentHTML
    ? sanitizeHtml(props.contentHTML, {
        allowedTags: constants.ALLOWED_TAGS,
        allowedSchemes: ["http", "https"]
      })
    : "";
  const innerHtml = {
    __html: sanitizedContent
  };
  return (
    <div className="WebPage">
      <div className="WebPage-Title">{props.title}</div>
      <div dangerouslySetInnerHTML={innerHtml} />
    </div>
  );
};

export default WebPage;



// WEBPACK FOOTER //
// ./src/components/Google/WebPage.js